import { encryptPayload, decryptResponse, decryptAxiosData } from "../utils/apiEnvelope";
import { getNewAuthToken, isTokenExpired } from "../utils";
import axios from "../utils/axios";
import setAuthToken from "../utils/setAuthToken";
import { baseURL } from "../utils/url";
import { encrypt } from "../utils/encodingdecoding";
import {
  GET_PROFILE_SETTING,
  UPDATE_PROFILE_SETTING,
  GET_FINANCIAL_ACCOUNT,
  CLEAR_SETTING,
} from "./type";

export const getProfile = (token, data) => async (dispatch) => {
  const valid = await isTokenExpired(token);

  try {
    if (!valid) {
      const res = await getNewAuthToken();
      localStorage.setItem("token_gen", JSON.stringify(res));
      token = res?.access_token;
    }

    const fetchResponse = await fetch(baseURL + "getprofile", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    const json = await decryptResponse(fetchResponse);

    dispatch({
      type: GET_PROFILE_SETTING,
      payload: json,
    });

    return json;

  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateProfile = (token, data) => async (dispatch) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        // console.log(res)
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "updateprofile", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(data),
    });
    decryptResponse(fetchResponse)
      .then((res) => {
        dispatch({
          type: UPDATE_PROFILE_SETTING,
          payload: res,
        });
        return res;
      })
      .catch(() => {
        return null;
      });
  } catch (error) {
    return error;
  }
};

export const getFinancialAccount = (token, id) => async (dispatch) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        // console.log(res)
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + "getfinancialaccount?id=" + id,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    decryptResponse(fetchResponse)
      .then((res) => {
        dispatch({
          type: GET_FINANCIAL_ACCOUNT,
          payload: res,
        });
        return res;
      })
      .catch(() => {
        return null;
      });
  } catch (error) {
    return error;
  }
};

export const merchantLogo = async (token, companyName, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        // console.log(res)
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `merchantBannerLogo?companyName=${encrypt(companyName)}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: formData,
      }
    );
    return decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};
export const vouchersImage = async (token, voucherTemplateCode, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        // console.log(res)
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `voucherImage?voucherTemplateCode=${voucherTemplateCode}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: formData,
      }
    );
    return decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};
export const merchantBanner = async (
  token,
  companyName,
  isBanner,
  isReciptUpload,
  inStoreRedeption,
  changeInisReciptUpload,
  changeIninStoreRedeption,
  file
) => {
  const formData = new FormData();
  formData.append("file", file);
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        // console.log(res)
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
      `merchantBannerLogo?companyName=${encrypt(companyName)}&isBanner=${encrypt(String(isBanner))}&isReciptUpload=${encrypt(String(isReciptUpload))}&inStoreRedeption=${encrypt(String(inStoreRedeption))}&changeInisReciptUpload=${encrypt(String(changeInisReciptUpload))}&changeIninStoreRedeption=${encrypt(String(changeIninStoreRedeption))}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: formData,
      }
    );
    return decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const merchantBannerData = async (
  token,
  companyName,
  isBanner,
  isReciptUpload,
  inStoreRedeption,
  changeInisReciptUpload,
  changeIninStoreRedeption,
  displayFirst,
  file
) => {
  const formData = new FormData();
  formData.append("file", file);
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        // console.log(res)
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
      `merchantBannerLogo?companyName=${encrypt(companyName)}&isBanner=${encrypt(String(isBanner))}&isReciptUpload=${encrypt(String(isReciptUpload))}&inStoreRedeption=${encrypt(String(inStoreRedeption))}&changeInisReciptUpload=${encrypt(String(changeInisReciptUpload))}&changeIninStoreRedeption=${encrypt(String(changeIninStoreRedeption))}&displayFirst=${displayFirst}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: formData,
      }
    );
    return decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const updateCatCache = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    setAuthToken(token);
    const fetchResponse = await axios.get(`updateCatCache`);
    return decryptAxiosData(fetchResponse?.data);
  } catch (error) {
    return error;
  }
};

export const clearSetting = () => async (dispatch) => {
  dispatch({ type: CLEAR_SETTING });
};

export const mediaUpload = async (token, merchantId, mediaName, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `postMediaUpload?merchantId=${encrypt(merchantId)}&mediaName=${encrypt(mediaName)}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: formData,
      }
    );
    return decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getMediaUpload = async (token, merchantId) => {
  try {
    const fetchResponse = await fetch(
      baseURL + `getMediaUpload?merchantId=${encrypt(merchantId)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteMediaUpload = async (token, id) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });

    const fetchResponse = await fetch(baseURL + `deleteMedia?id=${encrypt(id)}`, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};
